import React from 'react';

// Компонент хлебных крошек с parentPath и кликабельностью
function Breadcrumbs({ node, onCrumbClick }) {
  if (!node || !Array.isArray(node.parentPath)) return null;
  const crumbs = [...node.parentPath].reverse(); // теперь сначала верхний родитель
  crumbs.push({ id: node.id, title: node.title });
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, margin: '18px 0 18px 0', fontSize: 15, color: '#6a1b9a', flexWrap: 'wrap' }}>
      {crumbs.map((c, i) => (
        <span key={c.id} style={{ cursor: i < crumbs.length - 1 ? 'pointer' : 'default', fontWeight: i === crumbs.length - 1 ? 700 : 500 }}
          onClick={() => i < crumbs.length - 1 && onCrumbClick && onCrumbClick(c.id)}>
          {c.title}{i < crumbs.length - 1 && <span style={{ color: '#aaa', margin: '0 4px' }}>/</span>}
        </span>
      ))}
    </div>
  );
}

export default Breadcrumbs; 